import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import "../styles/newRouteInfo.scss";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";
import { InputAdornment, MenuItem } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";

const textFieldConfig = [
  {
    title: "Agency",
    key: "agency",
    placeholder: "Search to tag a MMO",
    select: true,
  },
  { title: "Route name", key: "name", placeholder: "Enter route name" },
  {
    title: "Description",
    key: "description",
    placeholder: "Route description",
  },
];

const radioLabelFreq = [
  { title: "Daily" },
  { title: "Weekly" },
  { title: "Biweekly" },
  { title: "Alternate Days" },
  { title: "Monthly" },
];

const CssTextField = withStyles({
  root: {
    fontFamily: "Inter",
    marginBottom: 30,
    fontSize: 14,

    "& .MuiInputBase-root": { fontFamily: "Inter" },
    "& .MuiSelect-select.Mui-disabled": {
      color: "#E91E63",
      cursor: "no-drop",
    },
    "& label.Mui-focused": {
      color: "#e2136e",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#e2136e",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 24,
      paddingLeft: 18,
      marginBottom: 0,
      fontSize: 14,
      height: 50,

      "& fieldset": {
        borderColor: "rgba(226, 232, 240, 1)",
        borderWidth: 1,
      },
      "&:hover fieldset": {
        borderColor: "rgba(226, 232, 240, 1)",
        cursor: "pointer",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#e2136e",
      },

      "& .MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
    },
  },
})(TextField);

const CustomRadio = withStyles({
  root: {
    fontSize: 13,
    color: "#e2136ea1",
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export default function FrequencyRadioGroup({
  agencies,
  routeInfo,
  onChangeRouteInfo,
  mode,
}) {
  const [value, setValue] = React.useState("female");
  const [frequency, setFrequency] = React.useState([]);
  //const [routeInfo, setRouteInfo] = React.useState({});

  React.useEffect(() => {
    getFrequencies();
  }, []);

  const getFrequencies = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/route_management/v1/frequency`,
        {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
          },
        }
      )
      .then((res) => {
        setFrequency(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeRadio = (event) => {
    onChangeRouteInfo({ ...routeInfo, frequency: event.target.value });
  };

  const handleChangeInput = (event) => {
    onChangeRouteInfo({ ...routeInfo, [event.target.id]: event.target.value });
  };

  const handleChangeInputSelect = (event) => {
    onChangeRouteInfo({ ...routeInfo, agency: event.target.value });
  };

  return (
    <div>
      <form noValidate autoComplete="off"></form>
      <FormControl component="fieldset">
        {textFieldConfig.map((item) =>
          !item.select ? (
            <CssTextField
              key={item.key}
              required={item.key === "description" ? false : true}
              id={item.key}
              label={item.title}
              variant="outlined"
              placeholder={item.placeholder}
              onChange={handleChangeInput}
              value={routeInfo[item.key]}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle style={{ opacity: 0.6 }} />
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <CssTextField
              required
              key={item.key}
              id={item.key}
              label={item.title}
              variant="outlined"
              placeholder={item.placeholder}
              select
              disabled={mode && mode === "edit" ? true : false}
              disabledStyle={{ color: "red" }}
              value={routeInfo.agency ? routeInfo.agency : ""}
              onChange={handleChangeInputSelect}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle
                      style={{
                        opacity: 0.6,
                        color: mode && mode === "edit" ? "#E91E63" : "black",
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            >
              {agencies.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </CssTextField>
          )
        )}
        <RadioGroup
          aria-label="frequency"
          onChange={handleChangeRadio}
          value={routeInfo.frequency ? routeInfo.frequency : ""}
        >
          {frequency.map((item) => (
            <div key={item.type} className="radio-group-container">
              <FormControlLabel
                value={item.id.toString()}
                control={<CustomRadio />}
                style={{ margin: 0 }}
              />
              <span>
                <h3>{item.type}</h3>
                {item.id === 5 || item.id === 6 ? (
                  <p>{item.days}</p>
                ) : (
                  <p>{item.description}</p>
                )}
              </span>
            </div>
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
}
